import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { Logo } from "@/components/brand/Logo";

const INV_LINKS = [
  { label: "Nuevos", href: "/inventario/nuevos", testid: "nav-inv-nuevos" },
  { label: "Seminuevos", href: "/inventario/seminuevos", testid: "nav-inv-seminuevos" },
  { label: "Promociones", href: "/inventario/promociones", testid: "nav-inv-promociones" },
];

const LINKS = [
  { label: "Cómo funciona", href: "/#proceso", testid: "nav-proceso" },
  { label: "Vender mi auto", href: "/#vender", testid: "nav-vender" },
  { label: "Comprar un auto", href: "/#comprar", testid: "nav-comprar" },
];

export default function PublicHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [invOpen, setInvOpen] = useState(false); // desktop hover/click state
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); setInvOpen(false); }, [pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors ${
        scrolled ? "border-[#3E5641]/10 bg-white" : "border-transparent bg-white"
      }`}
      data-testid="public-header"
    >
      <div className="container-x flex h-16 items-center justify-between">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          {/* Inventario dropdown — first item */}
          <div
            className="relative"
            onMouseEnter={() => setInvOpen(true)}
            onMouseLeave={() => setInvOpen(false)}
          >
            <button
              type="button"
              className="nav-link inline-flex items-center gap-1"
              onClick={() => setInvOpen((v) => !v)}
              aria-haspopup="true"
              aria-expanded={invOpen}
              data-testid="nav-inventario"
            >
              Inventario <ChevronDown size={14} />
            </button>
            {invOpen && (
              <div
                className="absolute left-0 top-full min-w-[180px] border border-[#3E5641]/10 bg-white py-2 shadow-sm"
                data-testid="nav-inventario-menu"
              >
                {INV_LINKS.map((l) => (
                  <Link
                    key={l.href}
                    to={l.href}
                    className="block px-4 py-2 text-sm text-[#3E5641] hover:bg-[#F1F3F3]"
                    data-testid={l.testid}
                  >
                    {l.label}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {LINKS.map((l) => (
            <a
              key={l.label}
              href={onHome ? l.href.replace(/^\//, "") : l.href}
              className="nav-link"
              data-testid={l.testid}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden items-center gap-3 md:flex">
          <Link to="/comprar" className="btn-primary !py-2 !px-4 text-sm" data-testid="header-start-credit-btn">
            Empezar mi crédito
          </Link>
        </div>
        <button
          className="md:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menú"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#3E5641]/10 bg-white md:hidden">
          <div className="container-x flex flex-col gap-4 py-6">
            <p className="mono text-[10px] uppercase tracking-widest text-[#6B7678]">Inventario</p>
            {INV_LINKS.map((l) => (
              <Link key={l.href} to={l.href} className="text-[#3E5641]" onClick={() => setOpen(false)} data-testid={`m-${l.testid}`}>
                {l.label}
              </Link>
            ))}
            <div className="my-2 h-px w-full bg-[#3E5641]/10" />
            {LINKS.map((l) => (
              <a
                key={l.label}
                href={onHome ? l.href.replace(/^\//, "") : l.href}
                className="text-[#3E5641]"
                onClick={() => setOpen(false)}
                data-testid={`m-${l.testid}`}
              >
                {l.label}
              </a>
            ))}
            <Link to="/comprar" className="btn-primary" onClick={() => setOpen(false)} data-testid="m-start-credit-btn">
              Empezar mi crédito
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
